import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcDateInputComponent } from './fc-date-input.component';


@NgModule({
  entryComponents: [
    FcDateInputComponent
  ],
  declarations: [
    FcDateInputComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatIconModule,
    MatDatepickerModule,
    PipesModule
  ],
  exports: [
    FcDateInputComponent
  ]
})
export class FcDateInputModule {}
